import * as types from '../../constants/ActionTypes';

const initstate = {
  notifications: [],
};

export default function (state = initstate, action) {
  const { type } = action;
  switch (type) {
    case types.NOTIFICATIONS_GET_MSGS_SUCCESS: {
      const { notifications } = action.payload;
      return {
        ...state,
        notifications,
      };
    }
    case types.NOTIFICATIONS_MARK_ARCHIVE_SUCCESS: {
      const { notification } = action.payload;
      const indx = state.notifications.findIndex((c) => c.id === notification.id);
      const notifications = [...state.notifications];
      notifications[indx] = notification;
      return {
        ...state,
        notifications,
      };
    }
    default:
      return state;
  }
}
